// eslint-disable-next-line no-unused-vars
import { motion, useMotionValue, animate } from "framer-motion"

import { useEffect, useState } from "react"

const AnimatedNumber = ({ value, decimals = 0 }) => {
  const motionValue = useMotionValue(0)
  const [display, setDisplay] = useState(value)

  useEffect(() => {
    const controls = animate(motionValue, value, {
      duration: 0.8,
      ease: [0.12, 0.15, 0.2, 0.3, 1],
      onUpdate: (latest) => {
        setDisplay(Number(latest.toFixed(decimals)))
      }
    })

    return controls.stop
  }, [value, motionValue, decimals])

  return (
    <motion.span>
      {display.toLocaleString(undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
      })}
    </motion.span>
  )
}

export default AnimatedNumber
